<template>
  <b-row>
    <b-col cols="12">
      <email-notification-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmailNotificationEditForm from './EmailNotificationEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    EmailNotificationEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
